import React, { useState, useEffect } from 'react';
import { useField } from 'formik';
import { useSnackbar } from 'notistack';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';

import subcategoriesClient from '../../../../../../clients/subcategories';

const toSelectedIds = (val) =>
  Array.isArray(val) ? val.map((v) => (typeof v === 'object' && v != null && 'id' in v ? v.id : v)) : [];

const useStyles = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
}));

const SubcategorySelectField = ({ categoryId, ...props }) => {
  const classes = useStyles();
  const [{ value: selectedValues }, , { setValue }] = useField(props.name);
  const { enqueueSnackbar } = useSnackbar();
  const [subcategories, setSubcategories] = useState([]);
  const selectedIds = toSelectedIds(selectedValues);

  // Normalize form value to ids so Select and checkboxes work when API returns objects
  useEffect(() => {
    if (
      Array.isArray(selectedValues) &&
      selectedValues.length > 0 &&
      selectedValues.some((v) => typeof v === 'object' && v != null && 'id' in v)
    ) {
      setValue(toSelectedIds(selectedValues));
    }
  }, [selectedValues, setValue]);

  useEffect(() => {
    if (!categoryId) {
      setSubcategories([]);
      return;
    }

    (async () => {
      try {
        const data = await subcategoriesClient.find({
          sort: 'Order:asc'
        });

        setSubcategories(data.filter(subcategory => subcategory.category?.id === categoryId));
      } catch (error) {
        enqueueSnackbar(
          'Nepavyko gauti subkategorijų. Bandykite atidaryti iš naujo.',
          { variant: 'error' }
        );
        setSubcategories([]);
      }
    })();
  }, [enqueueSnackbar, categoryId]);

  if (subcategories === undefined) {
    return <CircularProgress />;
  }

  if (subcategories.length === 0) {
    return null;
  }

  const renderValue = (selected) => {
    const ids = toSelectedIds(selected);
    const selectedItems = ids
      .map((id) => subcategories.find((s) => s.id === id))
      .filter(Boolean);
    return (
      <Box className={classes.chips}>
        {selectedItems.map((item) => (
          <Chip key={item.id} label={item.Title || ''} size="small" />
        ))}
      </Box>
    );
  };

  return (
    <SelectField multiple {...props} renderValue={renderValue}>
      {subcategories.map(({ id, Title }) => (
        <MenuItem key={id} value={id}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={selectedIds.indexOf(id) !== -1}
              tabIndex={-1}
              disableRipple
            />
          </ListItemIcon>
          <ListItemText primary={Title} />
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default SubcategorySelectField;
